import type { FormulaNode } from './parser'
import type { FormulaFunctionMap } from './functions'
import type { ValueProvider } from './provider'

export interface EvalContext {
  functions: FormulaFunctionMap
  provider: ValueProvider
}

// 비동기 evaluator만 유지, 함수명은 evaluateFormula로 단순화
export async function evaluateFormula(node: FormulaNode, ctx: EvalContext): Promise<any> {
  switch (node.type) {
    case 'number':
      return node.value
    case 'variable':
      return await ctx.provider.get(node.name)
    case 'function': {
      const fn = ctx.functions[node.name]
      if (!fn) throw new Error('Unknown function: ' + node.name)
      const args = await Promise.all(node.args.map(arg => evaluateFormula(arg, ctx)))
      return fn(...args)
    }
    case 'binary': {
      const l = await evaluateFormula(node.left, ctx)
      const r = await evaluateFormula(node.right, ctx)
      switch (node.op) {
        case '+':
          return l + r
        case '-':
          return l - r
        case '*':
          return l * r
        case '/':
          return l / r
        default:
          throw new Error('Unknown operator: ' + node.op)
      }
    }
    case 'unary':
      if (node.op === '-') return -(await evaluateFormula(node.arg, ctx))
      throw new Error('Unknown unary operator: ' + node.op)
    default:
      throw new Error('Unknown node type: ' + (node as any).type)
  }
}
